module.exports = __webpack_public_path__ + "img/export-cloud.svg";